import styled from 'styled-components';
import { rgba } from 'polished';
import { colors } from '@alixpartners/ui-components';

import { white, black, grey500 } from 'styles/colors';
import { mMedium, xsRegular } from 'styles/typography';
import { sectionWidth } from 'styles/spacings';
import { slideIn } from 'styles/animation';

export const Wrapper = styled.section`
	background-color: ${white};
	max-width: ${sectionWidth};
	min-width: ${sectionWidth};
	width: 100%;
	padding: 16px 32px 32px 32px;
	margin-top: 32px;
	box-shadow: 0 3px 10px 0 ${rgba('#000', 0.1)};
	animation-name: ${slideIn};
	animation-duration: 600ms;
	animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
	animation-delay: ${({ animationIndex }) => `${50 + animationIndex * 75}ms`};
	animation-fill-mode: backwards;

	&:first-child {
		margin-top: 0;
	}
`;

export const Title = styled.span`
	display: flex;
	width: 100%;
	${mMedium};
	color: ${black};
	margin-bottom: 4px;
`;

export const Description = styled.span`
	display: block;
	width: 100%;
	${xsRegular};
	color: ${grey500};
`;

export const Divider = styled.div`
	height: 1px;
	width: 100%;
	background-color: ${colors.grey2};
	margin-top: 16px;
	margin-bottom: 17px;
`;

export const ColsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 14px;

	${Description} {
		width: 278px;
		min-width: 278px;

		font-size: 13px;
		font-style: normal;
		font-weight: 400;
		line-height: 19px;
		letter-spacing: 0.3px;
		color: ${colors.grey7};
		margin-right: 111px;

		p + p {
			margin-top: 12px;
		}
	}
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
`;
